"use strict";
//Corey Wunderlich 2022
//https://www.wundervisionenvisionthefuture.com/
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapNavigation = void 0;
const Move_1 = require("./trackbuilder/Move");
const Point3D_1 = require("./trackbuilder/Point3D");
class MapNavigation {
    constructor(width, height, x, y, z) {
        this.point = new Point3D_1.Point3D(x, y, z);
        this.startingPoint = this.point;
        this.width = width;
        this.height = height;
        this.depth = 4;
        this.h = 0;
        this.map = [];
        this.moves = [];
        for (let x = 0; x < this.width; x++) {
            this.map.push([]);
            for (let y = 0; y < this.height; y++) {
                this.map[x].push([]);
                for (let z = 0; z < this.depth; z++) {
                    this.map[x][y].push(-10);
                }
            }
        }
    }
    MoveToStart() {
        this.point = this.startingPoint;
    }
    Move(dir) {
        this.map[this.point.x][this.point.y][this.point.z] = dir;
        this.point = this.GetPointInDir(dir);
        if (dir != 5 && dir != 6) {
            this.h = this.GetWorldDirection(dir);
        }
        this.moves.push(new Move_1.Move(dir, this.point));
    }
    GetMove() {
        return this.map[this.point.x][this.point.y][this.point.z];
    }
    NextMove() {
        let newh = this.GetMove();
        this.point = this.GetPointInDir(newh);
        if (newh != 5 && newh != 6) {
            this.h = this.GetWorldDirection(newh);
        }
        console.log(this.point);
    }
    CheckBound(x, y, z) {
        return (x < 0 || y < 0 || z < 0 || x >= this.width || y >= this.height || z >= this.depth);
    }
    TestDirection(dir) {
        let point = this.GetPointInDir(dir);
        return !this.CheckBound(point.x, point.y, point.z) && this.map[point.x][point.y][point.z] === -10;
    }
    GetWorldDirection(dir) {
        let newh = this.h + dir;
        if (newh < 0) {
            newh += 4;
        }
        ;
        if (newh == 4)
            newh = 0;
        return newh;
    }
    ChangeZ(up) {
        if (up) {
            return new Point3D_1.Point3D(this.point.x, this.point.y, this.point.z + 1);
        }
        else {
            return new Point3D_1.Point3D(this.point.x, this.point.y, this.point.z - 1);
        }
    }
    GetPointInDir(dir) {
        if (dir == 5 || dir == 6) {
            return this.ChangeZ(dir == 5);
        }
        else {
            let newh = this.GetWorldDirection(dir);
            switch (newh) {
                case 1: return new Point3D_1.Point3D(this.point.x + 1, this.point.y, this.point.z);
                case 2: return new Point3D_1.Point3D(this.point.x, this.point.y - 1, this.point.z);
                case 3: return new Point3D_1.Point3D(this.point.x - 1, this.point.y, this.point.z);
                case 0:
                default:
                    return new Point3D_1.Point3D(this.point.x, this.point.y + 1, this.point.z);
            }
        }
    }
}
exports.MapNavigation = MapNavigation;
